// import ReferralEditor from './referralEditor'
// import JobEditor from './editor.vue'

export default [
  // {
  //   name: 'addJob',
  //   path: '/v-admin/job/add',
  //   component: JobEditor,
  //   meta: {
  //     isEditMode: false,
  //     permission: { strict: false, any: ['PERM_JOB_CREATE', 'PERM_JOB_CREATE_FROM_TEMPLATE'] },
  //     titleI18nKey: 'admin.job.editor.title.addJob',
  //     rootLayout: {
  //       hiddenBackgroundImage: true,
  //       hiddenTabList: true,
  //       flexMode: true
  //     }
  //   }
  // },
  // {
  //   name: 'editJob',
  //   path: '/v-admin/job/edit/:jobId',
  //   component: JobEditor,
  //   meta: {
  //     isEditMode: true,
  //     permission: 'PERM_JOB_EDIT',
  //     titleI18nKey: 'admin.job.editor.title.editJob',
  //     rootLayout: {
  //       hiddenBackgroundImage: true,
  //       hiddenTabList: true,
  //       flexMode: true
  //     }
  //   }
  // },
  // {
  //   name: 'jobReferralEditor',
  //   path: '/v-admin/job/:jobId/referral',
  //   component: ReferralEditor,
  //   meta: {
  //     permission: 'COMPUTED_COMPANY_HAS_REFERRAL',
  //     titleI18nKey: 'admin.job.referral.title'
  //   }
  // }
]
